import styled from 'styled-components';

const PaymentWrapper = styled.div`
    *{
      text-align: initial;
    }

    h2{
        font-size: 24px;
        text-align: initial;
        color: #4c565c;
    }

`;

export default PaymentWrapper;